import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/common/useAuth'
import { isEmailVerified } from '@/utils/firebaseAuth'
import { auth } from '@/utils/firebaseConfig'
import { LoadingSpinner } from '@/components/common/ui/loading-spinner'

interface EmailVerificationRouteProps {
  children: React.ReactNode
}

export function EmailVerificationRoute({ children }: EmailVerificationRouteProps) {
  const { user, loading } = useAuth()

  // 認証状態の取得中はローディング表示
  if (loading || (!user && auth.currentUser)) {
    return <LoadingSpinner />
  }

  // ユーザーが認証されていない場合はログインページへ
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // メール認証が完了している場合はスペースページへ
  if (isEmailVerified()) {
    if (user.spaces?.[0]?.id) {
      return <Navigate to={`/space/${user.spaces[0].id}`} replace />
    } else {
      return <Navigate to="/" replace />
    }
  }

  // 認証済みだがメール未認証の場合のみページを表示
  return <>{children}</>
}
